module.exports = __webpack_public_path__ + "img/D.c58d4d38.png";